import React, { Suspense } from 'react';

function LazyComponent(props) {
  return (
    <Suspense
      fallback={
        <div className='h-screen flex items-center justify-center'>
          Loading...
        </div>
      }
    >
      {props.component}
    </Suspense>
  );
}

export default LazyComponent;
